import type { InternalTreeMapNode } from '../types/internal.js';

type Node = InternalTreeMapNode;

const sortAscending = (a: Node, b: Node) => a.value - b.value;
const sortDescending = (a: Node, b: Node) => b.value - a.value;

const sortNodes = (nodes: InternalTreeMapNode[], order: 'asc' | 'desc') => {
  const sortFunction = order === 'asc' ? sortAscending : sortDescending;
  return nodes.sort(sortFunction);
};

/**
 * Function to copy and sort tree 2 levels deep
 * @param rootNode - InternalTreeMapNode
 * @returns - sorted InternalTreeMapNode
 */
export const getSortedTree = (rootNode: InternalTreeMapNode) => {
  const clusters: InternalTreeMapNode[] = sortNodes(
    rootNode.children ?? [],
    'asc',
  );

  const children = clusters.map((cluster) => {
    const { children, ...clusterRest } = cluster;
    return {
      ...clusterRest,
      children: sortNodes(cluster.children ?? [], 'desc'),
    };
  });

  return { ...rootNode, children };
};
